<template>
  <div class="content">
    <img class="banner" :src="state.bannerlist?.full_img" alt="" />
    <!-- <div
      class="banner"
      :style="`background-image:url(${state.bannerlist?.full_img})`"
    ></div> -->
  </div>
  <div class="about">
    <div class="thehome">
      <span @click="topath('/')">{{ $t("header.home") }} </span>&nbsp;/
    </div>
    <div class="title">
      <div class="one animate__animated animate__backInLeft">
        {{ $t("header.join") }}
      </div>
      <div
        class="detail animate__animated"
        v-for="(item, index) in state.joinuslist"
        :key="index"
        v-show="getVShow(index)"
        :class="(index == 2 && 'animate__backInLeft') || 'animate__backInUp'"
      >
        <div class="typetitle icon">
          {{ (locale == "zh" && item.title) || item.en_title }}
        </div>
        <div
          class="foldtitle"
          v-for="(vitem, index) in item.details"
          :key="index"
        >
          {{ (locale == "zh" && vitem.list) || vitem.en_list }}
        </div>
        <div class="futitle">
          {{ (locale == "zh" && item.intro) || item.en_intro }}
        </div>
      </div>
      <div
        class="membership animate__animated animate__backInUp"
        v-show="state.d3"
        @click="topath('/membership')"
      >
        <div>{{ $t("header.Fill_in_the_membership_form") }}</div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { joinus } from "@/api/type";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const router = useRouter();
const state = reactive({
  d1: false,
  d2: false,
  d3: false,
  joinuslist: [],
  bannerlist: [],
  banners: "",
});
const handleScroll = () => {
  const scrollY = window.scrollY || window.pageYOffset;
  if (scrollY > 100) {
    state.d1 = true;
    state.d2 = true;
  }
  if (scrollY > 100) {
    state.d3 = true;
  }
};
joinus().then((res) => {
  // , res.data[2]
  state.joinuslist = [res.data[0], res.data[1]];
  state.bannerlist = res.data.banner;
  state.banners = res.data.banner.full_img;
  // console.log(res.data.banner, state.joinuslist, 987);
});
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});
const topath = (e) => {
  router.push(e);
};
const getVShow = (index) => {
  console.log(index, 989898);
  if (index == 1) {
    return state.d1;
  } else if (index == 2) {
    return state.d2;
  } else {
    // 如果index不是1或2，可以返回其他默认值
    return true; // 或 false，或根据需求设定
  }
};
</script>
<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  z-index: 0;
  max-width: 1468px;
  margin: 0 auto;
  height: 500px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .banner {
    height: 100%;
    position: absolute;
    // width: 100%;
    top: 0;
    bottom: 0;
    // background-image: url("https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
.about {
  max-width: 1176px;
  margin: 0 auto;
  text-align: left;
  .thehome {
    margin: 28px 0 80px 0;
    @include fontstyle(#333, 14px, 400, auto);
  }
  .title {
    display: flex;
    flex-direction: column;
    align-items: center;

    .one {
      text-align: center;
      display: inline-block;
      @include fontstyle(#333, 40px, 800, auto);
      line-height: 47px;
      margin-bottom: 48px;
      border-bottom: 8px solid #f4775e;
      padding-bottom: 3px;
    }
    // :nth-child(2) {
    //   margin-bottom: 80px;
    //   @include fontstyle(#333, 16px, 400, auto);
    //   line-height: 26px;
    // }
    .detail {
      --animate-duration: 1.5s;

      @include fontstyle(#333, 16px, 400, auto);
      margin-bottom: 40px;
      line-height: 26px;
      width: 100%;
      .typetitle {
        @include fontstyle(#3657db, 22px, 800, auto);
        margin-bottom: 24px;
      }
      .icon {
        display: flex;
        align-items: center;
        &::before {
          content: url(https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/join_icon_octothorpe.svg);
          margin-right: 5px;
        }
      }
      .foldtitle {
        @include fontstyle(#333, 18px, 800, auto);
        margin-bottom: 12px;
      }
      .futitle {
        @include fontstyle(#333, 18px, 400, auto);
      }
    }
    .membership {
      --animate-duration: 1.5s;
      width: 100%;
      // display: block;
      margin-bottom: 94px;
      display: flex;
      align-items: center;
      cursor: pointer;
      :nth-child(1) {
        @include fontstyle(#333, 20px, 800, pointer);
        // text-decoration: underline;
        border-bottom: 3px solid #333;
        padding-bottom: 2px;
      }
      :nth-child(2) {
        width: 28px;
        height: 28px;
        background: #333333;
        border-radius: 50%;
        margin-left: 16px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.5s;
        &:hover {
          background: #3f58de;
        }

        &::before {
          content: url("https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/joi(1).svg");
          display: block;
          // width: 100%;
          position: absolute;
          // top: -9%;
          // right: 50%;
          // transform: translate(50%, 50%);
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .about {
    padding: 30px;
  }
}
@media screen and (max-width:768px){
  .content {
    height: auto;
    .banner {
      width: 100%;
      height: auto;
    }
  }
}
</style>
